import { defineComponent as r, computed as m, watch as s } from "vue";
import u from "./index35.js";
import p from "./index36.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as a, setShowMobileMenu as d } from "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { useNavigationEventBus as c } from "@ado/acs-standard-library";
import y from "./index10.js";
const h = "100vh", l = "sticky", q = r({
  name: "MobileHeader",
  components: {
    SearchModalMobile: u,
    MobileMenu: p,
    HeaderLogo: y
  },
  props: {
    showSearch: {
      type: Boolean,
      default: !0
    },
    showHamburgerMenu: {
      type: Boolean,
      default: !0
    },
    config: {
      type: Object,
      required: !0
    },
    bannerStyle: {
      type: String,
      required: !0
    }
  },
  setup() {
    const t = (e) => {
      d(e);
    }, o = m(() => a().showMobileMenu), i = document.body.style.height;
    s(o, (e) => {
      e ? (document.body.style.height = h, document.body.style.position = l) : (document.body.style.height = i, document.body.style.position = "");
    });
    const n = c();
    return {
      setShowMenu: t,
      showMenu: o,
      navigationEventBus: n
    };
  }
});
export {
  q as default
};
//# sourceMappingURL=index33.js.map
